module.exports = __webpack_public_path__ + "static/media/why_el.b4b18366.vtt";